<template>
  <div>
    <!-- <connection></connection>
    <choice></choice>
    <answer></answer>
    <multipleChoice></multipleChoice> -->
    <!-- <connection></connection> -->
    <!-- <chineseComposition></chineseComposition> -->
    <div style="width: 800px;height: 600px;margin: 30px auto;">
      <quillEditor></quillEditor>
    </div>
    <handWrite></handWrite>
    <el-button @click="openDrawing">打开 </el-button>
    <drawingBoard ref="drawingBoard"></drawingBoard>
  </div>
</template>

<script>
// import connection from '@/components/question/connection.vue';
// import choice from '@/components/question/choice.vue';
// import answer from '@/components/question/answer.vue';
// import multipleChoice from '@/components/question/multipleChoice.vue';
// import quillEditor from "@/components/quillEditor/index.vue"
// import connection from './components/connection.vue';
// import chineseComposition from './components/chineseComposition.vue';
import quillEditor from "@/components/quillEditor/index.vue";
import handWrite from "@/components/handWrite/index.vue"
import drawingBoard from "@/components/quillEditor/drawingBoard.vue";
export default {
  name: 'GjkcH5Index',
  components: {
    // connection,
    // choice,
    // answer,
    // multipleChoice,
    // connection,
    // chineseComposition,
    quillEditor,
    handWrite,
    drawingBoard
  },

  data() {
    return {

    };
  },

  mounted() {

  },

  methods: {
    openDrawing(){
      this.$refs.drawingBoard.drawingBoardShow = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
}

.progress-container {
  flex: 1;
  min-width: 300px;
  background: #f8f9fa;
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}


.progress-wrapper {
  position: relative;
  height: 60px;
  margin: 40px 0;

  .progress-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #e0e0e0;
    /* 特殊形状裁剪 */
    clip-path: polygon(0 0,
        calc(100% - 30px) 0,
        100% 50%,
        calc(100% - 30px) 100%,
        0 100%,
        30px 50%);
    border-radius: 5px;
  }

  .progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(90deg, #2ecc71, #27ae60);
    /* 相同的特殊形状裁剪 */
    clip-path: polygon(0 0,
        calc(100% - 30px) 0,
        100% 50%,
        calc(100% - 30px) 100%,
        0 100%,
        30px 50%);
    border-radius: 5px;
    transition: width 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
  }
}

.progress-container111 {
  margin: 40px;
  position: relative;
  height: 60px;

  .progress-track {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .progress-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #e0e0e0;
    transition: all 0.5s ease;
  }

  .progress-fill {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(90deg, #2ecc71, #27ae60);
    transition: width 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55);
    box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.1);
  }

  /* 左侧圆角 + 右侧三角形 */
  .progress-bg.type1 {
    border-radius: 20px 0 0 20px;
    clip-path: polygon(0 0,
        calc(100% - 30px) 0,
        100% 50%,
        calc(100% - 30px) 100%,
        0 100%);
  }

  .progress-fill.type1 {
    border-radius: 20px 0 0 20px;
    clip-path: polygon(0 0,
        calc(100% - 30px) 0,
        100% 50%,
        calc(100% - 30px) 100%,
        0 100%);
  }

  /* 左侧三角形 + 右侧圆角 */
  .progress-bg.type2 {
    border-radius: 0 20px 20px 0;
    clip-path: polygon(0 50%,
        30px 0,
        100% 0,
        100% 100%,
        30px 100%);
  }

  .progress-fill.type2 {
    border-radius: 0 20px 20px 0;
    clip-path: polygon(0 50%,
        30px 0,
        100% 0,
        100% 100%,
        30px 100%);
  }
}
</style>